<template>
    <div class="login-wrapper">
        <div class="login-bigBox">
            <!-- 关闭页面按钮-->
            <span class="iconfont icon-guanbi opp" style="color: #fff" @click="closeClick"></span>
            <div class="top">
                <div
                    class="register-top_no leftRadius register-top_left"
                    :class="{ up: leftMenu == 1 }"
                    @click="routerLink(1)"
                >
                    单位注册
                </div>
                <div
                    class="register-top_no rightRadius register-top_right"
                    :class="{ up: leftMenu == 2 }"
                    @click="routerLink(2)"
                >
                    个人注册
                </div>
            </div>
            <!-- 单位注册-->
            <div class="register-container" v-show="leftMenu == 1">
                <Form
                    class="login-form"
                    :model="organizationForm"
                    :rules="organizationFormRules"
                    ref="organizationFormRef"
                >
                    <!--手机号-->
                    <FormItem prop="number" class="form-item">
                        <div class="icon-phone">
                            <div class="iconfont icon-shouji icon-phone_child"></div>
                        </div>
                        <!-- @on-blur="changeUserName" -->
                        <Input class="login-input" placeholder="请输入手机号" v-model="organizationForm.number"></Input>
                        <span class="iconfont icon-guanbi on" style="color: #999999" @mousedown="clickIcon"></span>
                    </FormItem>
                    <!--机构名称-->
                    <FormItem prop="name" class="form-item">
                        <div class="icon-phone">
                            <div class="iconfont icon-jigou1 icon-phone_child"></div>
                        </div>
                        <Input class="login-input" placeholder="请输入机构名称" v-model="organizationForm.name"></Input>
                        <span class="iconfont icon-guanbi on" style="color: #999999" @mousedown="clickIcon1"></span>
                    </FormItem>
                    <!--密码-->
                    <FormItem prop="password" class="form-item">
                        <div class="icon-phone">
                            <div class="iconfont icon-lock icon-phone_child"></div>
                        </div>
                        <Input
                            class="login-input"
                            :type="pwdType"
                            placeholder="请输入密码"
                            v-model="organizationForm.password"
                        ></Input>
                        <span :class="eyes ? icon1 : icon2" @click="yanjing" style="color: #999999"></span>
                    </FormItem>
                    <!--验证码-->
                    <FormItem prop="messageCode" class="form-item">
                        <div class="icon-phone">
                            <div class="iconfont icon-xinxi icon-phone_child"></div>
                        </div>
                        <Input
                            class="login-code"
                            placeholder="请输入短信验证码"
                            v-model="organizationForm.messageCode"
                        ></Input>
                        <div class="mac" @click="getCode" v-if="show">获取短信验证码</div>
                        <div class="mac" v-else>{{ count }}秒后重新获取</div>
                    </FormItem>
                    <div class="login-text">
                        <span>已有账号？</span>
                        <span class="register" style="color: #fd6621" @click="goLogin">前往登录</span>
                        <span class="iconfont icon-arrow-more" style="color: #fd6621"></span>
                    </div>
                    <button class="button-login" @click.prevent="toRegister('organizationFormRef')">
                        立即注册
                    </button>
                    <!--用户协议-->
                    <div class="login_xieyi">
                        <div class="checkbox">
                            <input type="checkbox" id="checkmark" v-model="agree" value="F" />
                            <label for="checkmark">
                                <i class="iconfont icon-dui"></i>我已阅读并同意
                                <span class="orange" style="cursor: pointer" @click="showUserAgreement"
                                    >《注册协议》</span
                                >
                            </label>
                        </div>
                    </div>
                </Form>
            </div>
            <!-- 个人注册-->
            <div class="register-container" v-show="leftMenu == 2">
                <Form class="login-form" :model="personForm" :rules="personFormRules" ref="formInline">
                    <!--手机号-->
                    <FormItem prop="number" class="form-item">
                        <div class="icon-phone">
                            <div class="iconfont icon-shouji icon-phone_child"></div>
                        </div>
                        <Input
                            class="login-input"
                            placeholder="请输入手机号"
                            v-model="personForm.number"
                            @on-blur="changeName"
                        ></Input>
                        <span class="iconfont icon-guanbi on" style="color: #999999" @mousedown="clickIcon3"></span>
                    </FormItem>
                    <!--密码-->
                    <FormItem prop="password" class="form-item">
                        <div class="icon-phone">
                            <div class="iconfont icon-lock icon-phone_child"></div>
                        </div>
                        <Input
                            class="login-input"
                            :type="pwdType"
                            placeholder="请输入密码"
                            v-model="personForm.password"
                        ></Input>
                        <span :class="eyes ? icon1 : icon2" @click="yanjing" style="color: #999999"></span>
                    </FormItem>
                    <!--验证码-->
                    <FormItem prop="messageCode" class="form-item">
                        <div class="icon-phone">
                            <div class="iconfont icon-xinxi icon-phone_child"></div>
                        </div>
                        <Input
                            class="login-code"
                            placeholder="请输入短信验证码"
                            v-model="personForm.messageCode"
                        ></Input>
                        <div class="mac" @click="personGetCode" v-if="show">
                            获取短信验证码
                        </div>
                        <div class="mac" v-else>{{ count }}秒后重新获取</div>
                    </FormItem>
                    <FormItem class="form-examiner" style="margin-left: 60px">
                        <Checkbox v-model="single"> 申请成为考官</Checkbox>
                    </FormItem>
                    <div class="login-text">
                        <span>已有账号？</span>
                        <span class="register" style="color: #fd6621" @click="goLogin">前往登录</span>
                        <span class="iconfont icon-arrow-more" style="color: #fd6621"></span>
                    </div>
                    <button class="button-login" @click.prevent="personToRegister('formInline')">
                        立即注册
                    </button>
                    <!--用户协议-->
                    <div class="login_xieyi">
                        <div class="checkbox">
                            <input type="checkbox" id="p-checkmark" v-model="p_agree" value="F" />
                            <label for="p-checkmark">
                                <i class="iconfont icon-dui"></i>我已阅读并同意
                                <span class="orange" style="cursor: pointer" @click="showUserAgreement"
                                    >《注册协议》</span
                                >
                            </label>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
        <div></div>
    </div>
</template>

<script>
import bus from "@/util/bus"

export default {
    name: "toRegister", //注册账号
    data() {
        return {
            single: false, // 是否成为考官
            userType: 1,
            leftMenu: 1,
            eyes: "iconfont icon-yanjing on",
            icon2: "iconfont icon-yanjing1 on",
            icon1: "iconfont icon-yanjing on",
            pwdType: "password",
            showForgetPwdPop: false,
            tabValue: "organization",
            organization: "",
            person: "",
            show: true, // 展示获取验证码或倒计时按钮判断
            count: "", //倒计时提示文字
            //机构注册账号的数据绑定
            organizationForm: {
                number: "",
                name: "",
                password: "",
                //imgCode:'',
                //codeSrc:'url',
                messageCode: "",
            },
            //机构注册表单验证规则
            organizationFormRules: {
                number: [
                    { required: true, message: "请输入手机号码", trigger: "blur" },
                    {
                        pattern: /^1[3456789]\d{9}$/,
                        message: "手机号码格式不正确",
                        trigger: "blur",
                    },
                ],
                name: [{ required: true, message: "请输入机构名称", trigger: "blur" }],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                    {
                        min: 6,
                        max: 15,
                        message: "长度在 6 到 15 个字符",
                        trigger: "blur",
                    },
                ],
                /* imgCode: [
                         {required: true, message: "请输入图形验证码", trigger: "blur"}
                     ],*/
                messageCode: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
            },
            //个人注册账号的数据绑定
            personForm: {
                number: "",
                // name: "",
                password: "",
                //imgCode: '',
                //codeSrc:'url',
                messageCode: "",
            },
            //个人注册表单验证规则
            personFormRules: {
                number: [
                    { required: true, message: "请输入手机号码", trigger: "blur" },
                    {
                        pattern: /^1[3456789]\d{9}$/,
                        message: "手机号码格式不正确",
                        trigger: "blur",
                    },
                ],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                    {
                        min: 6,
                        max: 15,
                        message: "长度在 6 到 15 个字符",
                        trigger: "blur",
                    },
                ],
                /*imgCode: [
                        {required: true, message: "请输入图形验证码", trigger: "blur"}
                    ],*/
                messageCode: [{ required: false, message: "请输入短信验证码", trigger: "blur" }],
            },
            agencyCode: "",
            agree: false,
            p_agree: false,
        }
    },
    methods: {
        //控制眼睛图标的切换
        yanjing() {
            this.pwdType = this.pwdType === "password" ? "text" : "password"
            this.eyes = !this.eyes
        },

        clickIcon() {
            this.organizationForm.number = ""
        },
        clickIcon1() {
            this.organizationForm.name = ""
        },
        clickIcon3() {
            this.personForm.number = ""
        },
        routerLink(index) {
            this.leftMenu = index
        },
        //验证码有效期提示
        info1(nodesc) {
            this.$Notice.info({
                title: "提示",
                desc: nodesc ? "" : "验证码有效期为2分钟，过期需要重新获取. ",
            })
        },
        //判断机构是否存在
        // changeUserName() {
        //     let query = {
        //         logonUser: this.organizationForm.number
        //     }
        //     this.$Axios.post('userInfo/checkUserExist', query).then(res => {
        //         console.log(res);
        //         // if (res.success !== true) {
        //         //     this.$Message.error(res.errors[0].message);
        //         //     return;
        //         // } else if (res.success !== true && res.data === 'Y') {
        //         //     this.$Message.error(res.errors[0].message);
        //         //     return;
        //         // }
        //         /*
        //              * 如果手机号不符合规范或者代码错误，直接抛错。（success:false, data:null）
        //              * 如果手机号存在, 直接返回true。（success:true, data:'Y'）
        //              * 如果手机号不存在, 直接返回true. (success: true, data: 'N')
        //          */
        //         if (res.success === false || (res.success === true && res.data === 'Y')) {
        //             this.$Message.error(res.message);
        //         }
        //     }).catch(res => {
        //         this.$Message.error(res.message);
        //     });
        // },
        //获取短信验证码(机构注册)
        getCode() {
            this.$Axios
                .post("openApis/sendSMS", {
                    mobileNo: this.organizationForm.number,
                    // loginCheck: true
                })
                .then((res) => {
                    if (res.success !== true) {
                        this.$Message.error(res.errors[0].message)
                        return
                    }
                    this.agencyCode = res.data
                    this.info1(false)
                    const TIME_COUNT = 60
                    if (!this.timer) {
                        this.count = TIME_COUNT
                        this.show = false
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= TIME_COUNT) {
                                this.count--
                            } else {
                                this.show = true
                                clearInterval(this.timer)
                                this.timer = null
                            }
                        }, 1000)
                    }
                })
                .catch((res) => {
                    this.$Message.error(res.message)
                })
        },
        //注册(机构注册)
        toRegister(name) {
            let query = {
                logonUser: this.organizationForm.number,
            }
            this.$Axios.post("userInfo/checkUserExist", query).then((res) => {
                if (res.success === false || (res.success === true && res.data === "Y")) {
                    return this.$Message.error(res.message)
                }
                this.$refs[name].validate((valid) => {
                    if (!this.agree) {
                        this.$Message.warning("请勾选协议！")
                        return false
                    }
                    if (valid) {
                        this.$Axios
                            .post("userInfo/registUser", {
                                checkCode: this.organizationForm.messageCode,
                                logonUser: this.organizationForm.number,
                                name: this.organizationForm.name,
                                pwd: this.organizationForm.password,
                                userType: 2,
                            })
                            .then((res) => {
                                console.log(res)
                                if (res.success) {
                                    this.$Message.success("注册成功！")
                                    // this.$router.push("/");
                                    window.location.reload()
                                } else {
                                    this.$Message.error(res.errors[0].message)
                                }
                            })
                            .catch((res) => {
                                this.$Message.error(res.errors[0].message)
                            })
                    } else {
                        this.$Message.error("注册失败，请重试!")
                    }
                })
            })
        },
        //判断用户是否存在
        changeName() {
            let query = {
                logonUser: this.personForm.number,
            }
            this.$Axios
                .post("userInfo/checkUserExist", query)
                .then((res) => {
                    // if (res.success !== true) {
                    //     this.$Message.error(res.errors[0].message);
                    //     return;
                    // } else if (res.success !== true && res.data === 'Y') {
                    //     this.$Message.error(res.errors[0].message);
                    //     return;
                    // }
                    if (res.success === false || (res.success === true && res.data === "Y")) {
                        this.$Message.error(res.message)
                    }
                })
                .catch((res) => {
                    this.$Message.error(res.message)
                })
        },
        //获取短信验证码(个人注册)
        personGetCode() {
            this.$Axios
                .post("openApis/sendSMS", {
                    mobileNo: this.personForm.number,
                })
                .then((res) => {
                    console.log(res)
                    if (res.success !== true) {
                        this.$Message.error(res.errors[0].message)
                        return
                    }
                    this.info1(false)
                    const TIME_COUNT = 60
                    if (!this.timer) {
                        this.count = TIME_COUNT
                        this.show = false
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= TIME_COUNT) {
                                this.count--
                            } else {
                                this.show = true
                                clearInterval(this.timer)
                                this.timer = null
                            }
                        }, 1000)
                    }
                })
                .catch((res) => {
                    this.$Message.error(res.message)
                })
        },
        showUserAgreement() {
            let siteInfo = this.$store.getters["sessions/getSiteInfo"]
            window.open(siteInfo.userAgreement)
            // siteInfo.uploadCtrl
        },

        closeClick() {
            bus.$emit("showLogin", 4)
        },
        //注册(个人注册)
        personToRegister(name) {
            if (!this.p_agree) {
                return this.$Message.warning("请勾选协议！")
            }
            this.userType = this.single ? 3 : 1;
            this.$refs[name].validate(async (valid) => {
                if (valid) {
                    const resRegister = await this.$Axios.post("userInfo/registUser", {
                        checkCode: this.personForm.messageCode,
                        logonUser: this.personForm.number,
                        pwd: this.personForm.password,
                        userType: this.userType,
                    })
                    //   console.log(123, resRegister);
                    //   如果success为true就提示注册成功
                    /*    if (resRegister.success) {
            this.$Message.success("注册成功！");
            // 提示注册成功清空输入框======================
            this.personForm.number = "";
            this.personForm.messageCode = "";
            this.personForm.password = "";
          } else {
            this.$Message.error(resRegister.errors[0].message);
          } */

                    if (resRegister.success) {
                        // 注册考官直接跳过登录
                        const resLogin = await this.$Axios.post("userInfo/login ", {
                            logonUser: this.personForm.number,
                            pwd: this.personForm.password,
                        })
                        this.$store.dispatch("sessions/setUserinfo", resLogin.data)
                        bus.$emit("showLogin", 4)
                        bus.$emit("jumpToDetail", 1)
                        if(this.userType === 3){
                            this.$router.push({
                                path: "/personalCenter/examinerInfo",
                                query: {
                                    isAdd: true,
                                    logonUser: this.personForm.number,
                                    checkCode: this.personForm.messageCode,
                                },
                            })
                        }
                        this.personForm.number = ""
                        this.personForm.messageCode = ""
                        this.personForm.password = ""
                        this.$Message.success("注册成功！")
                    } else {
                        this.$Message.error("验证码错误或超时！")
                    }
                    // this.$Axios.post("userInfo/registUser", {
                    //     checkCode: this.personForm.messageCode,
                    //     logonUser: this.personForm.number,
                    //     pwd: this.personForm.password,
                    //     userType: this.userType
                    // }).then(res => {
                    //     if (res.success) {
                    //         this.$Message.success("注册成功！");
                    //         if (this.userType === 3) {
                    //
                    //           });
                    //         }
                    //         // window.location.reload();
                    //     } else {
                    //         this.$Message.error(res.errors[0].message);
                    //     }
                    // }).catch(res => {
                    //     this.$Message.error(res.errors[0].message);
                    // });
                } else {
                    this.$Message.error("注册失败，请重试!")
                }
            })
        },

        //前往登录
        goLogin() {
            bus.$emit("showLogin", 1)
        },
    },
    mounted() {},
}
</script>

<style lang="less" scoped>
.up {
    width: 250px;
    height: 60px;
    background-color: #fd6621;
    color: #fff;
    /*color: #fff;
        text-align: center;
        line-height: 60px;*/
}

.top {
    width: 500px;
    height: 60px;
    background-color: rgba(0, 0, 0, 0);
    display: flex;
    align-items: flex-end;
    font-size: 18px;
    cursor: pointer;
}
.login_xieyi {
    margin-top: 13px;
    line-height: 1;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/login/toRegister.vue